import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function ImmigrationSection({ data,immigrationTopText }) {
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(
    data.cards.findIndex((c) => c.active) || 0,
  );

  return (
    <div className="immigration-section py-5">
      <div className="custom-container">
        <div className="row align-items-center">
          {/* LEFT */}
          <div className="col-lg-6 mb-4 mb-lg-0">
            <h2 className="main-title FS40FW600">
              <span className="text-success FS40FW600">{data.title}</span> <br />
              {data.highlight}
            </h2>

            <div className="info-box academy-highlight-box FS16FW500 mt-3 mb-4">{data.description}</div>

            <button className="primary-btn mt-3" onClick={() => navigate(data?.buttonLink||'/auth/register')}>{data.buttonText} <img src="/images/web-new-images/right-arrow.svg" alt="Register Now" /></button>
          </div>

          {/* RIGHT */}
          <div className="col-lg-6">
            <div className="right-content">
              <p className="quote-box FS18FW400">{data.rightText}</p>

              <ul className="feature-list">
                {data.benefits.map((b, i) => (
                  <li key={i} className="FS18FW400">{b}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* CARDS */}
        <div className="row mt-5 g-3">
          {data.cards.map((card, i) => {
            // const isActive = i === activeIndex;
            return (
              <div className="col-lg-3 col-md-6" key={i}>
                {/* ${isActive ? "active" : ""} */}
                <div
                  className={`immi-card`}
                  onClick={() => setActiveIndex(i)}
                >
                  <div className="top-row">
                    {/* <span className="doc-icon"><img src={`/images/web-new-images/${isActive ? 'document-selected.svg':'document-not-selected.svg'}`} alt="Register Now" /></span> */}
                    <span className="doc-icon">
                      <img
                        className="icon-default"
                        src="/images/web-new-images/document-not-selected.svg"
                        alt=""
                      />
                      <img
                        className="icon-active"
                        src="/images/web-new-images/document-selected.svg"
                        alt=""
                      />
                    </span>
                    <span className="immigration-badge FS14FW600 plus-sans">{card.badge}</span>
                  </div> 

                  <p className="plus-sans FS18FW400 fw-600">{card.title}</p>
                  <p className="subtitle FS16FW500 plus-sans">{card.subtitle}</p>

                  <div className="bottom-row">
                    <span className="FS16FW500 plus-sans subtitle">Target</span>
                    <span className="target FS14FW600">{card.target}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* FOOTER TEXT */}
        <p className="card-subtitle text-center mt-4 plus-sans FS18FW400">
          The PTE Core test ensures you have the necessary communication skills
          to integrate successfully into <br/> Canadian society and workplace
          environments.
        </p>
      </div>
    </div>
  );
}
